import { defineComponent as _defineComponent } from 'vue';
import Vue, { ref } from "vue";
import ContentItem from "./ContentItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GenericElement',
    props: {
        dsc: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const expandCollections = ref({});
        const expandDatasets = ref({});
        function toggle(expansionMap, itemId) {
            Vue.set(expansionMap, itemId, !expansionMap[itemId]);
        }
        return { __sfc: true, expandCollections, expandDatasets, toggle, ContentItem };
    }
});
